import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import { Tooltip, useMediaQuery } from '@mui/material';
import { formatDate, getFirstPreviewImage, hasAccessRights } from '../../../../../shared/functions/Functions';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { useTranslation } from 'react-i18next';
import { CampaignHeaderButtons } from '../../components/CampaignHeaderButtons';
import { CampaignChangeMobile } from '../../components/CampaignChangeMobile';
import { AccessRightEnum } from '../../../../../enum/AccessRightEnum';
import { BootstrapBreakpoints } from '../../../../../enum/BootstrapBreakpoints';

export function CampaignOverviewDetail() {
    const { campaign } = useSelector((state: IAllStates) => state.selectedCampaign);
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const isMobile = useMediaQuery(`(max-width: ${BootstrapBreakpoints.MD}px)`);

    return (
        <div>
            <div className="position-relative">
                {getFirstPreviewImage('style_uploaded_image', campaign?.campaignImages, 'moonboard-images w-100')}
                {isMobile && (
                    <div className="d-flex align-items-center top-right-icon">
                        <CampaignHeaderButtons setShow={setShow} campaign={campaign} />
                    </div>
                )}
                {isMobile && (
                    <p className={`status ${campaign?.status} place-bottom-right`}>
                        {t(`general.campaign_status.${campaign?.status}`)}
                    </p>
                )}
                <div className="position-absolute w-100" style={{ top: '60px' }}>
                    {show && <CampaignChangeMobile setShow={setShow} />}
                </div>
            </div>
            <div className="d-flex justify-content-between mt-3">
                <div className="mr-2">
                    <h6 className="d-flex justify-content-center mb-1">
                        {campaign?.mainPlatforms?.length ? (
                            campaign?.mainPlatforms?.slice(0, 3)?.map(platform => (
                                <div className="mr-1" key={platform?.id}>
                                    <CustomImageHandler
                                        photoPath={platform?.path as string}
                                        altTag={`${platform?.id}`}
                                        thumbnailPath={platform?.thumbnail ?? null}
                                    />
                                </div>
                            ))
                        ) : (
                            <span className="text-primary">-</span>
                        )}
                        {(campaign?.mainPlatforms?.length ?? 0) > 3 && (
                            <Tooltip
                                id="white-tooltip"
                                title={
                                    <>
                                        {campaign?.mainPlatforms?.slice(3)?.map(platform => (
                                            <div className="mx-1 my-2" key={platform?.id}>
                                                <CustomImageHandler
                                                    style={{ height: 33 }}
                                                    photoPath={platform?.path as string}
                                                    altTag={`${platform?.id}`}
                                                    thumbnailPath={platform?.thumbnail ?? null}
                                                />
                                            </div>
                                        ))}
                                    </>
                                }
                                placement="right"
                                className="cursor-pointer"
                            >
                                <span className="icon-round bg-dark font-weight-semi-bold" style={{ width: 33 }}>
                                    + {(campaign?.mainPlatforms?.length ?? 0) - 3}
                                </span>
                            </Tooltip>
                        )}
                    </h6>
                    <p className="mb-0">{t('general.statistics.platforms')}</p>
                </div>
                {campaign?.isLongTerm ? (
                    <div className="w-50 align-content-end">
                        <h6 className="text-primary mb-1">
                            {!!campaign?.invoiceDuration
                                ? t(`brand.campaign.briefing.step3.campaign_duration_enum.${campaign?.invoiceDuration}`)
                                : '-'}
                        </h6>
                        <p className="mb-0">{t('brand.campaign.briefing.step3.campaign_duration')}</p>
                    </div>
                ) : (
                    <div className="w-50 align-content-end">
                        <h6 className="text-primary mb-1">
                            {campaign?.publishFrom ? formatDate(campaign?.publishFrom as string) : 'DD.MM.YYYY.'} -
                            {campaign?.publishTo ? formatDate(campaign?.publishTo as string) : ' DD.MM.YYYY.'}
                        </h6>
                        <p className="mb-0">{t('brand.campaign.dashboard.pub_period')}</p>
                    </div>
                )}
            </div>
            <div className="d-flex justify-content-between mt-3 pb-2 border-bottom mb-2">
                {campaign?.isLongTerm ? (
                    <div className="mr-2">
                        <h6 className="text-primary mb-1">
                            {campaign?.date ? formatDate(campaign?.date as string) : 'DD.MM.YYYY.'}
                        </h6>
                        <p className="mb-0">{t('brand.campaign.briefing.step3.start_date')}</p>
                    </div>
                ) : (
                    <div className="mr-2">
                        <h6 className="text-primary mb-1">
                            {campaign?.date ? formatDate(campaign?.date as string) : 'DD.MM.YYYY.'}
                        </h6>
                        <p className="mb-0">{t('brand.campaign.dashboard.app_deadline')}</p>
                    </div>
                )}
                {campaign?.isCharity || hasAccessRights(AccessRightEnum.MEASURE_HIDE_COSTS) ? (
                    <></>
                ) : (
                    <div className="w-50">
                        <h6 className="text-primary euro-symbol mb-1">{priceSplitter(campaign?.grossBudget ?? 0)}</h6>
                        <p className="mb-0">{t('brand.campaign.dashboard.campaign_budget')}</p>
                    </div>
                )}
            </div>
        </div>
    );
}
